import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import PlacesIndex from "screens/places/Index.jsx";
import ThemesIndex from "screens/themes/Index.jsx";
import SeoTemplatesIndex from "screens/seo/Index.jsx";
import AnalyticsIndex from "screens/analytics/Index.jsx";
import SettingsHome from "screens/settings/Index.jsx";
import ThemeIndex from "screens/themes/theme/Index.jsx";
import PlanEdit from "screens/settings/pages/plan/Edit.jsx";

import PlanConfirmation from "screens/settings/pages/plan/Confirmation.jsx";

import NotFound from "components/global/NotFound.jsx";

import { AppContext } from "./appContext.jsx";
export default function AppRoutes(props) {
  const { plan } = useContext(AppContext);

  if (!plan)
    return (
      <Routes>
        <Route path="/" element={<PlanEdit />} />
        <Route
          path="/settings/plan/confirmation"
          element={<PlanConfirmation />}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );

  return (
    <Routes>
        <Route path="/" element={<Navigate to="/places/*" />} />
      <Route path="/places/*" element={<PlacesIndex />} />
      <Route
        path="/places/locations/import"
        element={<PlacesIndex importStage={"upload"} />}
      />

      <Route path="/analytics" element={<AnalyticsIndex />} />

      <Route path="/themes" element={<ThemesIndex />} />
      <Route path="/themes/:id/*" element={<ThemeIndex />} />

      <Route path="/settings/*" element={<SettingsHome />} />

      <Route path="/seo-templates/*" element={<SeoTemplatesIndex />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
